import { Box } from "@chakra-ui/react"

export const ErrComp = ({children, ...props}) => {
  return <Box {...{textAlign: 'center', fontSize: '2xl', ...props}}>
    {children}
  </Box>
}